import { Type } from "@feathersjs/typebox";
export const CoordinateSchema = Type.Array(Type.Number(), { minItems: 2, maxItems: 3 });
export const polygonSchema = Type.Object({
    type: Type.Literal("Polygon"),
    coordinates: Type.Array(Type.Array(CoordinateSchema)),
});
export const LineStringSchema = Type.Object({
    type: Type.Literal("LineString"),
    coordinates: Type.Array(CoordinateSchema),
});
//# sourceMappingURL=geojsonSchema.js.map